<template>
    <div>
        <nav :class="classList">
            <div class="container">
                <a class="gh-logo" href="/">
                    <img :src="logoSrc" alt="Salon X Papas Logo">
                </a>

                <div v-if="screenWidth >= 1112" class="gh-menu">
                    <ul class="gh-menu-list" v-show="isOpened">
                        <li v-for="item in menu"
                            :key="item.label"
                            class="gh-menu-item">
                            <v-btn text class="gh-menu-link" :href="item.url">{{ item.label }}</v-btn>
                        </li>
                    </ul>
                    <v-btn
                            text
                            :ripple="false"
                            class="gh-nav-button"
                            @click="toggleMenu">
                        <v-icon v-if="isOpened">close</v-icon>
                        <div v-else>
                            Menu
                            <v-icon>add</v-icon>
                        </div>
                    </v-btn>
                </div>
                <div v-else class="gh-menu-mobile" :class="dark ? 'is-dark' : ''">
                    <v-btn
                            text
                            large
                            color="white"
                            @click.stop="drawer = !drawer"
                    >
                        Menu
                        <v-icon right dark>add</v-icon>
                    </v-btn>
                </div>
            </div>
        </nav>
        <v-navigation-drawer
                v-model="drawer"
                right
                fixed
                dark
                temporary
                floating
        >
            <v-list nav>
                <v-list-item v-for="item in menu" :key="item.label">
                    <v-list-item-content>
                        <a class="gh-menu-link" :href="item.url">{{ item.label }}</a>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
  export default {
    name: 'ghNavigatorMain',

    props: {
      menu: {
        type: Array,
        required: true
      },

      dark: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isOpened: true,
        drawer: false,
        screenWidth: window.innerWidth
      }
    },

    computed: {
      classList() {
        return [
          'gh-nav',
          this.isOpened ? 'is-opened' : '',
          this.dark ? 'is-dark' : ''
        ]
      },

      logoSrc() {
        if (this.dark) return '/images/SXP-White-Logo.svg'

        return this.isOpened ? '/images/SXP-White-Logo.svg' : '/images/SXP-Black-Logo.svg'
      }
    },

    mounted() {
      window.addEventListener("resize", this.resize)
    },

    methods: {
      toggleMenu() {
        this.isOpened = !this.isOpened
      },

      resize() {
        this.screenWidth = window.innerWidth
      }
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.resize);
    }
  }
</script>

<style scoped lang="sass">
    .gh-nav
        position: fixed
        top: 0
        width: 100%
        height: 64px
        background: transparent
        transition: background 1s
        z-index: 1

        &.is-opened
            background: rgba(#000, .5)
            color: #fff

        > .container
            display: flex
            align-items: center
            justify-content: space-between
            height: 100%
            padding: 1rem 0

        .gh-menu
            display: flex

        .gh-menu-list
            display: flex
            margin-right: 2rem
            padding: 0
            list-style: none

        .gh-menu-item
            + .gh-menu-item
                margin-left: 1rem

        .gh-nav-button
            text-transform: inherit
            color: #fff
            font-size: 1.2rem

            .is-dark &
                color: #fff

        .gh-logo
            display: flex
            align-items: center

    .gh-menu-link
        color: #fff
        font-size: 1rem

    .theme--dark.v-navigation-drawer
        background: #000

        @media (max-width: 1366px)
            .gh-nav
                position: relative
</style>
